import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=7cfc4bd0&scoped=true&ref=adminUser&"
import script from "./Positions.vue?vue&type=script&lang=js&"
export * from "./Positions.vue?vue&type=script&lang=js&"
import style0 from "./Positions.vue?vue&type=style&index=0&id=7cfc4bd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfc4bd0",
  null
  
)

export default component.exports